'use strict';

import { logger } from '../logger';

export function dispatchCommand() {
  logger.warn('dispatchCommand() is not supported on web.');
}
